import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel } from "common/models/utility-models/meta-model";

export class studentNotificationGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Notifications',
            ROUTE_PATH.studentNotificationGrid,
            '',
            false,
            false,
            8,
            false,
            false,
  
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
       
     
        return headers;
    }
}